import * as React from 'react';
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridRowClickEvent,
  GridRowDoubleClickEvent,
  GridSortChangeEvent,
  GRID_COL_INDEX_ATTRIBUTE
} from '@progress/kendo-react-grid';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { SvgIcon } from '@progress/kendo-react-common';
import { getName, formatBytes } from '../helpers/helperMethods';

const DateCreatedCell  = (props: GridCellProps) => {
  const field: string = props.field || '';
  const rawDate = props.dataItem[field];
  const date: Date = rawDate instanceof Date ? rawDate : new Date(rawDate);
  const navigationAttributes = useTableKeyboardNavigation(props.id);

  return (
    <td
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {date === null ? '' : date.toLocaleDateString()}
    </td>
  );
};

const SizeCell = (props: GridCellProps) => {
  const size: number = props.dataItem[props.field ?? ''];
  const isDirectory: boolean = props.dataItem['isDirectory'];
  const navigationAttributes = useTableKeyboardNavigation(props.id);

  return (
    <td
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {isDirectory ? '-' : formatBytes(size)}
    </td>
  );
};

const NameCell = (props: GridCellProps) => {
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  const name = getName(props.dataItem.path);
  const { svgIcon } = props.dataItem.icon;

  return (
    <td
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      <SvgIcon icon={svgIcon} />
      <span className="ms-1">{name}</span>
    </td>
  );
};

export const GridView = (props: any) => {
  const RowRender = (trElement: any, dataItem: any) => {
    const trProps = {
      onContextMenu: (event: any) => {
        event.preventDefault()
        handleContextMenu(event, dataItem);
      }
    }
    return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
  };

  const handleOnSortChange = (event: GridSortChangeEvent) => {
    props.onSortChange({
      sort: event.sort,
      event: event
    });
  };

  const handleSelectionChange = (event: GridRowClickEvent) => {
    props.onSelectionChange(event);
  };

  const handleDoubleClick = (event: GridRowDoubleClickEvent) => {
    props.onDoubleClick(event);
  };

  const handleContextMenu = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, dataItem: any) => {
    props.onContextMenu({
      dataItem: dataItem.dataItem,
      event: event
    });
  };

  return (
    <Grid
      data={props.data}
      rowRender={RowRender}
      className={'k-filemanager-grid k-grid-display-block k-editable'}
      style={{ height: '100%' }}
      navigatable={true}
      sortable={{
        allowUnsort: false
      }}
      sort={props.sort}
      selectedField={'selected'}
      selectable={{ enabled: true, cell: false, drag: true, mode: 'multiple' }}
      dataItemKey={props.dataItemKey}
      onRowClick={handleSelectionChange}
      onSortChange={handleOnSortChange}
      onRowDoubleClick={handleDoubleClick}
      >
      <Column field='path' title='Name' cell={NameCell} />
      <Column field='lastModified' title='Date Modified' cell={DateCreatedCell} format='yyyy:mm:dd' />
      <Column field='size' title='Size' cell={SizeCell} />
    </Grid>
  );
}
